import { z } from 'zod';
import { writable } from 'svelte/store';
import { CustomerSettingsReadonlySchema } from '../lib/components/Settings/settings';

/**
 * Uprawnienia zalogowanego użytkownika, źródło: Settings::getMyPermissions().
 *
 * Świadomie bez .catch() i .default() - niepoprawny payload ma wywalić parsowanie, a nie po cichu
 * przyznać pełny dostęp. Dopóki uprawnienia nie zostaną wczytane, $app.permissions jest null.
 */
export const PermissionsSchema = z.object({
    canRead: z.boolean(),
    canWrite: z.boolean(),
    isUserManager: z.boolean(),
});
export type PermissionsType = z.infer<typeof PermissionsSchema>;

/**
 * Odpowiedź backendu (snake_case) na stan store'u. Rzuca ZodError, gdy brakuje którejkolwiek
 * flagi albo nie jest boolem - błąd kontraktu nie może skończyć się cichym pełnym dostępem.
 */
export function toPermissions(payload: unknown): PermissionsType {
    const raw = (payload ?? {}) as Record<string, unknown>;

    return PermissionsSchema.parse({
        canRead: raw.can_read,
        canWrite: raw.can_write,
        isUserManager: raw.is_user_manager,
    });
}

export const AppSchema = z.object({
    isAdmin: z.boolean(),
    account: z.any(), // Account class
    settingsReadonly: CustomerSettingsReadonlySchema.nullable(),
    permissions: PermissionsSchema.nullable(),
});
export type AppType = z.infer<typeof AppSchema>;

export const app = writable<AppType>({
    isAdmin: false,
    account: null,
    settingsReadonly: null,
    permissions: null,
});
